













import Vue from "vue";
import isNumber from "lodash-es/isNumber";
import isString from "lodash-es/isString";

export default Vue.extend({
  props: {
    classes: String,
    buttonText: String,
    variant: String,
    id: [Number, String],
    to: String,
    pressed: {
      type: Boolean,
      default: null
    }
  },
  methods: {
    onButtonClick(event: any) {
      this.$emit("clicked", this.id);
    }
  },
  computed: {
    getTo(): any {
      if (!this.to) return null;

      let params = {};
      if (isNumber(this.id) || isString(this.id))
        params = { id: String(this.id) };

      return { name: this.to, params: params };
    }
  }
});
